// extracted by mini-css-extract-plugin
export default {"container":"SubmitFooter_container__R1enR"};